import { logger } from '../logger'

const copyToClipboard = (str: string) => {
  const el = document.createElement('textarea')
  el.value = str

  el.setAttribute('readonly', '')
  el.style.position = 'absolute'
  el.style.left = '-9999px'

  document.body.appendChild(el)

  el.select()

  if (navigator.clipboard) {
    navigator.clipboard
      .writeText(str)
      .then(() => {
        document.body.removeChild(el)
      })
      .catch((error) => {
        logger.warn(
          'Clipboard API failed, falling back to legacy method:',
          error,
        )
        try {
          document.execCommand('copy')
          document.body.removeChild(el)
        } catch (legacyError) {
          logger.warn('Legacy copy method also failed:', legacyError)
          document.body.removeChild(el)
        }
      })
  } else {
    try {
      document.execCommand('copy')
      document.body.removeChild(el)
    } catch (error) {
      logger.warn('Legacy copy method failed:', error)
      document.body.removeChild(el)
    }
  }
}

export default copyToClipboard
